import React from 'react'
import { makeStyles } from '@material-ui/core/styles'
import { colors } from '@material-ui/core'
import { Helmet } from 'react-helmet'
import Section from '../../shared/Section'
import Hero from './Hero'
import Services from './Services'
// import Partners from './Pertners'
import PertnersSwiper from './PertnersSwiper'
import Integrations from './Integrations'
import Connecting from './Connecting'
import Reviews from './Reviews'
import HomeFeatures from './HomeFeatures'
import MakeConduiit from './MakeConduiit'
import HomeFooter from './HomeFooter'
// import Faq from './Faq'
import Minimal from '../../hoc/Minimal'
// import Users from './Users'
import {
  servicesData,
  partners,
  props,
  // users,
  reviews,
  // faq,
} from '../../description/Home'

const useStyles = makeStyles((theme) => ({
  root: {
    height: '100%',
    width: '100%',
  },
  landingHomePage: {
    background: '#fff',
  },
  heroSection: {
    paddingTop: 50,
    [theme.breakpoints.down('md')]: {
      paddingTop: 20,
    },
  },
  pagePaddingTop: {
    paddingTop: theme.spacing(3),
    [theme.breakpoints.up('md')]: {
      paddingTop: theme.spacing(5),
    },
  },
  sectionNoPaddingTop: {
    paddingTop: 0,
  },
  shape: {
    background: theme.palette.alternate.main,
    borderBottomRightRadius: '100%',
    borderBottom: `1px solid ${colors.grey[200]}`,
  },
  mainContainer: {
    maxWidth: 1366,
    width: '100%',
    margin: '0 auto',
    padding: '0 15px',
    [theme.breakpoints.down('1450')]: {
      maxWidth: 1200,
    },
    [theme.breakpoints.down('md')]: {
      padding: '0 40px',
    },
    [theme.breakpoints.down('xs')]: {
      padding: '0 24px',
    },
  },
  section: {
    paddingTop: 80,
    paddingBottom: 80,
    height: '100%',
    [theme.breakpoints.down('md')]: {
      paddingTop: 120,
    },
  },
  partnerContainer: {
    background: '#EEE8FC',
    maxWidth: '100%',
    padding: '100px 90px',
    [theme.breakpoints.down('1500')]: {
      padding: '80px 30px',
    },
    [theme.breakpoints.down('1500')]: {
      padding: '60px 15px',
    },
  },
  partnerContainerSwiper: {
    background: '#EEE8FC',
    maxWidth: '100%',
    padding: '60px 90px',
    marginTop: '20px',
    [theme.breakpoints.down('1500')]: {
      padding: '80px 30px',
    },
    [theme.breakpoints.down('1500')]: {
      padding: '60px 15px',
    },
  },
  connectContainer: {
    padding: '180px 0px 0',
    [theme.breakpoints.down('1500')]: {
      padding: '100px 0 0',
    },
  },
  featuresContainer: {
    background: '#7C45EF',
  },
  testimonialSection: {
    margin: '100px 0 0',
    padding: '150px 0',
    background: '#EEE8FC',
    [theme.breakpoints.down('md')]: {
      padding: '120px 0',
    },
    [theme.breakpoints.down('md')]: {
      padding: '85px 0',
    },
    [theme.breakpoints.down('xs')]: {
      margin: '30px 0 0',
    },
  },
  makeConduiitSection: {
    background: '#282828',
  },
  otherView: {
    marginTop: '20px',
    '&> .MuiGrid-container': {
      flexDirection: 'column',
      '& h5': {
        marginBottom: '20px',
        textAlign: 'center',
      },
    },
  },
  newColor: {
    backgroundColor: '#EEE8FC',
  },
}))

const Home = () => {
  const classes = useStyles()
  // useEffect(() => {
  //   const header = document.querySelector('header')

  //   document.addEventListener('scroll', () => {
  //     console.log('Hello')
  //     var scroll_position = window.scrollY
  //     // if (window.innerWidth > 768) {
  //     if (scroll_position > 30) {
  //       header.classList.add(classes.sticky)
  //     } else {
  //       header.classList.remove(classes.sticky)
  //     }
  //   })
  // })
  return (
    <>
      <Helmet>
        <meta
          name="keywords"
          content="Make production easier, Save time and money, Streamline the audit process, Reduce file management time, Reduce email clutter and data entry, Train new employees faster, Identify errors in advance, Receive real time notification, Build to connect, Dashboard, Approval matrix, Pre-build and customisable forms, Tables, views and file manager, About as"
        />
        <meta
          name="description"
          content="Cloud-based purchase order, payment request and file management system that allows production management and finance teams to work seamlessly, Conduiit saves you time and money by connecting fragmented processes and eliminating friction, Use Conduiit to perform pre-audits on transactions to identify missing qualified expenses and supporting documentation, Use Conduiit to upload and manage files, instead of assorted tools like DropBox, Box.com and Google Drive, Manage files, purchase orders, payment requests and approvals in Conduiit rather than email. Export detail to MediaWeb, ProBook, Luca, Showbiz, PSL and other production accounting softwares, Use Conduiit to guide new production office and accounting employees instead of checklists and procedures memos, Use Conduiit to identify miscoded submissions, missing files and unapproved submissions,Use Conduiit to get instant information about KPIs and other important information"
        />
      </Helmet>
      <div className={classes.landingHomePage}>
        <div className={classes.heroSection}>
          <Hero />
        </div>
        <div className={`${classes.mainContainer} ${classes.section}`}>
          <Services data={servicesData} />
        </div>
        {/* <div className={classes.partnerContainer}>
          <Partners data={partners} />
        </div>
        <div className={`${classes.partnerContainer} ${classes.otherView}`}>
          <Partners data={partners} />
        </div> */}
        <div className={classes.newColor}>
          <div className={`${classes.mainContainer} ${classes.section}`}>
            <PertnersSwiper data={partners} />
          </div>
        </div>
        <div className={classes.connectContainer}>
          <Connecting data={props} />
        </div>
        <div className={classes.featuresContainer}>
          <HomeFeatures />
        </div>
        <Section className={`${classes.mainContainer} ${classes.section}`}>
          <Integrations data={props} />
        </Section>
        {/* <SectionAlternate>
        <Contact data={props} />
      </SectionAlternate>
      <div className={classes.shape}>
        <Section className={classes.sectionNoPaddingTop}>
          <About data={servicesData} />
        </Section>
      </div> */}
        {/* <Section>
        <Users data={users} />
      </Section> */}
        <div className={classes.testimonialSection}>
          <Reviews data={reviews} />
        </div>
        <div className={classes.makeConduiitSection}>
          <MakeConduiit />
        </div>
        <div className="">
          <HomeFooter />
        </div>
        {/* <Section>
        <Features />
      </Section> */}
        {/* <div className={classes.shape}>
        <Section>
          <Pricings data={pricings} />
        </Section>
        <Section className={classes.sectionNoPaddingTop}>
          <Faq data={faq} />
        </Section>
      </div> */}
      </div>
    </>
  )
}

export default Minimal(Home)
